import { InputText, TextArea } from "@bluframe/blublocks"
import { ChangeEvent, useCallback } from "react"

import { ComponentProps } from "."
import { OverridesLabel, Wrapper } from "./styled"

const OverridesScoreQuoteAndSection = ({
  inputId,
  label,
  name,
  onUpdate,
  quote,
  score,
  section,
  serviceName
}: ComponentProps) => {
  const onScoreChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const raw = event.currentTarget.value
      onUpdate({ score: raw ? Number(raw) : undefined })
    },
    [onUpdate]
  )

  const onQuoteChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onUpdate({ quote: event.currentTarget.value })
    },
    [onUpdate]
  )

  const onSectionChange = useCallback(
    (event: ChangeEvent<HTMLTextAreaElement>) => {
      onUpdate({ section: event.currentTarget.value })
    },
    [onUpdate]
  )

  return (
    <Wrapper>
      <OverridesLabel>{label}</OverridesLabel>

      <InputText
        inputId={`${serviceName}-${inputId}-score`}
        label="Score"
        name={`${serviceName}-${name}-score`}
        onChange={onScoreChange}
        step="0.5"
        type="number"
        value={String(score ?? "")}
      />

      <TextArea
        inputId={`${serviceName}-${inputId}-quote`}
        label="Quote"
        name={`${serviceName}-${name}-quote`}
        onChange={onQuoteChange}
        value={quote ?? ""}
      />

      <TextArea
        inputId={`${serviceName}-${inputId}-section`}
        label="Section"
        name={`${serviceName}-${name}-section`}
        onChange={onSectionChange}
        value={section ?? ""}
      />
    </Wrapper>
  )
}
export default OverridesScoreQuoteAndSection
